import { truckBrandsApi } from "./truckBrands.api";

export const { useGetTruckBrandQuery, useGetTruckBrandsQuery, useLazyGetTruckBrandQuery, useLazyGetTruckBrandsQuery } = truckBrandsApi;
